import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects/experiences I've worked on or been a part of.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Drivers' heartbeat prediction using Deep Learning (Transformer) on multimodal driving data"
              description="Developed and designed multiple Transformer architectures attempting to yield the highest accuracy for predicting a drivers heartbeat. Dataset consisted of *millions* of datapoints and best performing model ~80% accuracy"
              ghLink="https://github.com/ahmadsmohammad/Machine-Learning-Transformers"
              demoLink="https://httpstatusdogs.com/503-service-unavailable"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="Some DSA coursework (C++). This was done in my sophomore year and includes different data structures such as Max/Min Heap, Linked List and more"
              ghLink="https://github.com/ahmadsmohammad/Data-Structures"
              demoLink="https://http.cat/503"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="This Website"
              description="This project was built using React.js, Node.js, Express.js, CSS3, VScode. This site is currently being hosted by GCP (FireBase) and I am looking to incorporating more cloud features!"
              ghLink="https://github.com/ahmadsmohammad/"
              demoLink="https://github.com/ahmadsmohammad/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Some Circuitry Coursework"
              description="Built an RSC (Relatively Simple Computer). Using Logic gates, memory components, and more. This was all done in Logism and deepened my understanding on how computers really work!"
              ghLink="https://github.com/ahmadsmohammad/Computer-Architecture-and-Assembly"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Artificial Intelligence Algorithms"
              description="I have a collection of algorithms commonly used in AI such as greedy, simulated annealing, id3, and more. I wrote and played with these algorithms in Python (ipynb) and some examples can be found through the link below!"
              ghLink="https://github.com/ahmadsmohammad/Artificial-Intelligence-Algorithms"
            // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Hospital Database Management System"
              description="In this project I am using Django and mySQL to build a Hospital Database Management System. There are various security policies in place such as Role Based Access, Encryption, Auditing and Logging and more. I plan on migrating this project to the cloud and eventually adding a demo link for you all to see."
              ghLink="https://github.com/ahmadsmohammad/DataBaseProject"
            // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
